export enum DetailUnitEnum {
  Timestamps = 'timestamps',
  Minutes = 'minutes',
  Hours = 'hours',
  Days = 'days',
  WeeksSunday = 'weeksSunday',
  WeeksMonday = 'weeksMonday',
  Months = 'months',
  Quarters = 'quarters',
  Years = 'years'
}
